<div class="p-2 sm:p-3 rounded-base h-full flex flex-col gap-3">
    <!-- Header -->
    <div class="flex justify-between sm:justify-end items-center flex-shrink-0 gap-2">
        <h2 class="font-bold text-lg sm:text-xl block sm:hidden">Status</h2>
        <app-button variant="filled" label="Add Status" severity="primary" icon="pi pi-plus" (clicked)="openAddDialog()"
            class="w-auto" />
    </div>

    <!-- List -->
    <div
        class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3 sm:gap-x-8 sm:gap-y-4 overflow-y-auto flex-1 content-start">
        @for(s of statuses;track s._id){
        <div class="flex justify-between gap-1 sm:gap-2 items-center min-w-0">
            <input type="text" [(ngModel)]="s.name"
                class="flex-1 min-w-0 p-1.5 sm:p-2 border rounded-base text-sm sm:text-base truncate"
                [disabled]="true" />
            <div class="flex items-center gap-1 flex-shrink-0">
                <!-- Edit -->
                <app-button variant="outlined" severity="contrast" icon="pi pi-pencil" (clicked)="openEditDialog(s)" />
                @if(!s.standardStatus){
                <!-- Delete (only non-standard) -->
                <app-button variant="outlined" severity="danger" icon="pi pi-trash" (clicked)="openDeleteDialog(s)" />
                }
            </div>
        </div>
        }
    </div>
</div>
<!-- Add/Edit Dialog -->
<app-dialog [(visible)]="showFormDialog" [title]="editing ? 'Edit Status' : 'Add Status'"
    (closed)="resetForm()" class="max-w-[500px]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="p-4">
            <input id="statusName" type="text" pInputText [(ngModel)]="form.name"
                class="w-full p-1.5 border rounded-base" placeholder="Enter status name" />
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex flex-col sm:flex-row justify-end gap-2">
            <app-button variant="outlined" label="Cancel" severity="contrast" icon="pi pi-times"
                (clicked)="showFormDialog=false" class="w-full sm:w-auto" />
            <app-button variant="filled" severity="primary" label="Save" icon="pi pi-save"
                [disabled]="!hasChanges" (clicked)="save()" class="w-full sm:w-auto" />
        </div>
    </ng-template>
</app-dialog>

<!-- Delete Confirmation -->
<app-dialog [(visible)]="showDeleteDialog" title="Delete Status" (closed)="showDeleteDialog=false"
    class="max-w-[500px]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <p class="p-4">Are you sure you want to delete "<b>{{ target?.name }}</b>"?</p>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex flex-col sm:flex-row justify-end gap-2">
            <app-button variant="outlined" label="Cancel" severity="contrast" icon="pi pi-times"
                (clicked)="showDeleteDialog=false" class="w-full sm:w-auto" />
            <app-button variant="filled" severity="danger" label="Delete" icon="pi pi-trash"
                (clicked)="confirmDelete()" class="w-full sm:w-auto" />
        </div>
    </ng-template>
</app-dialog>